import $req from '@/request'
import {getClientType} from '@/utils/index'
// fund-price 页面api
export const EEFundPirceLatestList = (data?:any) => $req({url: '/memberController/getLatestFundPriceList', data, method: 'POST'})

export const EEFundPirceHistoryList = (data?:any) => $req({url: '/memberController/getFundPriceListBySearchDate', data, method: 'POST'})

// fund-news 页面api
export const FundNewsSubMenuList = (controller: string, data?: any) => $req({url: `/${controller}/getFundNewsMenuList`, data, method: 'POST'})

export const FundNewsReportList = (controller: string, data?: any) => $req({url: `/${controller}/getFundNewsReportList`, data, method: 'POST'})

// fund-switching-request 页面api

export const EEFundSwitchingVerify = (data?:any) => $req({url: '/memberController/verifyFundSwitchingRequest', data, method: 'POST'});

// investment-plan 页面api

export const EEGetUserFundInfo  = (data?:any) => $req({url:'/memberController/getFundFactList',data, method:'POST'});

// risk-profile 页面api
export const EERiskProfileGetData = (data?:any) => $req({url: '/memberController/getRiskLevelAndTotalScore', data, method: 'POST'});
export const EECustomerSupportRiskProfileGetData = (data?:any) => $req({url: '/memberController/getCustomerSupportRiskLevelAndTotalScore', data, method: 'POST'});

// risk-profile-form 页面api
export const EESaveRiskProfileForm = (data?:any) => $req({url: '/memberController/saveRiskProfileForm', data, method: 'POST'});

// fund-switching-option 页面api
export const EEFundSwitchingOptions = (data?:any) => $req({url: '/memberController/getFundSwitchingOptions', data, method: 'POST'});
export const EEFundSwitchingVerifySubmitCount = (data?:any) => $req({url: '/memberController/verifySubmitCount', data, method: 'POST'});

// new-investment-plan 页面api
export const EEGetCurrentInvestmentPlanFundList = (data?:any) => $req({url: '/memberController/getCurrentInvestmentPlanFundList', data, method: 'POST'});

export const EEGetPlanOptions = (data?:any) => $req({url: '/memberController/getInvestmentPlanList', data, method: 'POST'});

export const EEGetSelectedInvestmentPlanFundList = (data?:any) => $req({url: '/memberController/getSelectedInvestmentPlanFundList', data, method: 'POST'});

export const EEGetSelectedFutureInvestmentPlanFundList = (data?:any) => $req({url:'/memberController/getSelectedFutureInvestmentPlanFundList', data, method: 'POST'});

export const EEConfirmFundSwitchingRequest = (data?:any) => $req({url: '/memberController/confirmFundSwitchingRequest', data, method: 'POST'});

export const EEVerifyFundSwitchingRequest = (data?:any) => $req({url: '/memberController/verifyFswRecord', data, method: 'POST'});

// acknowledge 页面api

export const EEDeleteFundSwitchingRequest = (data?:any) =>$req({url: '/memberController/deleteFundSwitchingRequest', data, method:'POST'});

// fund-switching-menu

export const EEGetCancelInfo = (data?:any) => $req({url: '/memberController/checkFSCancelMenuAvailable',data, method: 'POST'});

// fund-switching-enquiry
export const EEGetEnquiryInfo = (data?:any) => $req({url:'/memberController/getUserProfile', data, method:'POST'});

export const EEGetEnquiryFundSwitchingRequest = (data?:any) => $req({url: '/memberController/enquiryFundSwitchingRequestSummary', data, method: 'POST'});

export const EEGetCardDetailInfo = (data?:any) => $req({url: '/memberController/enquiryFundSwitchingRequestDetail', data, method: 'POST'});

// fund-form-download 页面api
export const ERFundFormReportList = (data?: any) => $req({ url: '/employerController/getCustomerSupportDownloadRecordList', data, method: 'POST'})

// fund-report 页面api
export const ERFundReportSubMenuList = (data?: any) => $req({ url: '/employerController/getFundReportMenuList', data, method: 'POST'})

export const ERFundReportList = (data?: any) => $req({ url: '/employerController/getFundReportList', data, method: 'POST'})


// logTracking api
export const EELogTracking = (data?: any) => $req({ url: '/memberController/logTracking', data: {...data, clientType : getClientType()}, method: 'POST'})

export const ERLogTracking = (data?: any) => $req({ url: '/employerController/logTracking', data: {...data, clientType : getClientType()}, method: 'POST'})
// fund-switching-cancellation

export const EEGetEnquiryFundSwitchingCancelRequest = (data?:any) => $req({url: '/memberController/enquiryFundSwitchingCancelRequestSummary', data, method: 'POST'});

export const EECancelRequest = (data?:any) => $req({url: '/memberController/cancelFundSwitchingRequest', data, method: 'POST'});

// download-corner 页面api

export const EEGetCustomerSupportDownloadRecordList = (data?:any) => $req({url:'/memberController/getCustomerSupportDownloadRecordList', data, method: 'POST'})

// account enquiries / BalanceByFund
export const EEGetgetBalanceByFund = (data?:any) => $req({url:'/memberController/getBalanceByFund', data, method: 'POST'})

// account enquiries / AccountMovement
export const EEgetAccountMovement = (data?:any) => $req({url:'/memberController/getAccountMovement', data, method: 'POST'})
export const EEDownloadAccountMovement = (params?:any) => $req({url:'/memberController/downloadAccountMovement', params, method: 'GET', responseType: 'blob'})
export const EEgetAccountMovementSearchData = (data?:any) => $req({url:'/memberController/getAccountMovementSearchData', data, method: 'POST'})

// account enquiries / Financial statement report
export const EEgetIndividualStatementDetails = (data?:any) => $req({url:'/memberController/getIndividualStatementDetails', data, method: 'POST'})
// account enquiries / Balance summary
export const EEgetBalanceSummaryByUserId = (data?:any) => $req({url:'/memberController/getBalanceSummaryByUserId', data, method: 'POST'})
// account enquiries / Investment proportion
export const EEgetInvestmentProportion = (data?:any) => $req({url:'/memberController/getInvestmentProportion', data, method: 'POST'})
// account enquiries / performance EE
export const EEgetgetPerformance = (data?:any) => $req({url:'/memberController/getPerformance', data, method: 'POST'})
// account enquiries / performance ER
export const ERgetgetPerformance = (data?:any) => $req({url:'/employerController/getPerformance', data, method: 'POST'})

// user-profile 页面api
export const GetUserProfile = (controller: string, data?:any) => $req({url:`/${controller}/getUserProfile`, data, method: 'POST'})
export const ChangeUserProfilePassword = (controller: string, data?:any) => $req({url:`/${controller}/changeUserProfilePassword`, data, method: 'POST'})
export const ValidateUserProfilePassword = (controller: string, data?:any) => $req({url:`/${controller}/validateChangeUserProfilePassword`, data, method: 'POST'})

// eeLogin
export const EElogin = (data?:any) => $req({url:'/memberController/login', data, method: 'POST'})
export const VerifyBannerImg = (data?: any) => $req({url:'/homepageController/verifyDownloadCampaignWebImage', data, method: 'POST'})
export const GetBannerText = (data?: any) => $req({url:'/homepageController/getCampaignWebContent', data, method: 'POST'})
export const GetEEStandardReportList = (data?: any) => $req({url:`/homepageController/getMemberStandardReportList`, data, method: 'POST'})

// erLogin
export const ERlogin = (data?:any) => $req({url:'/employerController/login', data, method: 'POST'})
export const GetERStandardReportList = (data?: any) => $req({url:`/homepageController/getEmployerStandardReportList`, data, method: 'POST'})

// logout
export const Logout = (controller: string, data?: any) => $req({url:`/${controller}/logout`, data, method: 'POST'})

// first-time-login 页面api
export const ChangeFirstPassword = (controller: string, data?:any) => $req({url:`/${controller}/changePassword`, data, method: 'POST'})
export const CheckIsFirstLogin = (controller: string, data?:any) => $req({url:`/${controller}/checkUserForShowTerms`, data, method: 'POST'})

// MFA 页面api
export const EnrollNewUser = (data?:any) => $req({url:`/employerController/enrollNewUser`, data, method: 'POST'})
export const ReEnrollNewUser = (data?:any) => $req({url:`/employerController/resendEmailEnrolmentVerificationCode`, data, method: 'POST'})
export const validateEmailVerificationCode = (data?:any) => $req({url:`/employerController/verifyEmailEnrolmentVerificationCode`, data, method: 'POST'})

export const EnrollMobileNumber = (data?:any) => $req({url:`/employerController/enrollMobileNumber`, data, method: 'POST'})
export const ReEnrollMobileNumber = (data?:any) => $req({url:`/employerController/resendMobileEnrolmentVerificationCode`, data, method: 'POST'})
export const validateMobileVerificationCode = (data?:any) => $req({url:`/employerController/verifyMobileEnrolmentVerificationCode`, data, method: 'POST'})

export const SendVerificationCode = (data?:any) => $req({url:`/employerController/sendVerificationCode`, data, method: 'POST'})
export const ResendVerificationCode = (data?:any) => $req({url:`/employerController/resendVerificationCode`, data, method: 'POST'})
export const ValidateVerificationCode = (data?:any) => $req({url:`/employerController/validateVerificationCode`, data, method: 'POST'})

export const RequestOktaChange = (data?:any) => $req({url:`/employerController/requestOktaChange`, data, method: 'POST'})
export const ChangeOktaUserEmail = (data?:any) => $req({url:`/employerController/changeOktaUserEmail`, data, method: 'POST'})
export const ChangeOktaUserPhone = (data?:any) => $req({url:`/employerController/changeOktaUserPhone`, data, method: 'POST'})
export const ChallengeOktaChange = (data?:any) => $req({url:`/employerController/challengeOktaChange`, data, method: 'POST'})
export const VerifyOktaChange = (data?:any) => $req({url:`/employerController/verifyOktaChange`, data, method: 'POST'})
export const DeleteOktaUserPhone = (data?:any) => $req({url:`/employerController/deleteOktaUserPhone`, data, method: 'POST'})

// download detail of inestment plan
export const DownloadInvestmentPlan = (params?:any) => $req({url:`/memberController/downloadDetailOfInvestmentPlan`, params, method: 'GET', responseType: 'blob'})

// verify token
export const VerifyToken = (data?:any) => $req({url:`/memberController/verifyToken`, data, method: 'POST'})
export const getKey = (data?:any) => $req({url:`/homepageController/getKey`, data, method: 'GET'})
